import React, { useState, useEffect, useMemo } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
// React Bootstrap components
import { Container, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { GetPartnerServicesList } from "../../API/endpoints/Partner";
import { partnerServiceCapabilities } from "../dtos/partner.dtos";
import "./PartnerServiceCapabilities.scss";
import ToastMessage from "../components/toasts/ToastMessage";
import { GetCountries } from "../../API/endpoints/Common";
import { Typography } from "@mui/material";
import Chip from "@mui/material/Chip";

import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddIcon from "@mui/icons-material/Add";
import Grid from "@mui/material/Grid";
import PartnerDropDown from "./PartnerDropDown";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Multiselect from "multiselect-react-dropdown";
import { EngagementModelDTO } from "../dtos/brand.dtos";
import PopupTemplate from "../components/PopupTemplate/PopupTemplate";
import { useForm } from "react-hook-form";
import { getFlagIcon } from "../../common/helpers";
import { createMarket, updateMarket } from "../../API/endpoints/Market";

interface MarketFromInputs {
  market: number;
  services: any[];
  engagement_model: any[];
  exclusivity: number;
  minimum_tenure: string;
  shipment_terms: [];
  category_focus: [];
  payment_terms: [];
  investments: number;
  remarks: "";
}

function PartnerServiceCapabilitiesNew(props: {
  setDefaultTab: (arg0: string) => void;
  isActivePartner: boolean;
  isSuperAdmin: boolean;
  partnerID: any;
  countries: any[] | [];
  permissions: any;
  engagementModelList: EngagementModelDTO[];
  categories: any[] | [];
  tenureList: any[] | [];
  servicesList: any[] | [];
  onContinue: (tab: string, status: boolean, data?: any) => void;
  data: any[] | [];
  reload: (arg0?: boolean) => void;
}) {
  const params = useParams();

  const [open, setOpen] = React.useState("");
  // const [openMarket, setOpenMarket] = React.useState(false);
  // const handleCloseMarket = () => setOpen (false);

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    setError,
    clearErrors,
  } = useForm<MarketFromInputs>();
  //   {
  //   defaultValues: {
  //     market: "",
  //     services: [],
  //     engagement_model: [],
  //     exclusivity: 1,
  //     minimum_tenure: -1,
  //     shipment_terms: [],
  //     category_focus: [],
  //     payment_terms: [],
  //     investments: -1,
  //     remarks: "",
  //   },
  // }

  const handleClickOpenMarket = () => {
    setOpen("add");
  };
  const handleCloseMarket = () => {
    setOpen("");
    setSelectedServices([]);
    setSelectedEngagementModels([]);
    setSelectedCategories([]);
    setSelectedPaymentTerms([]);
    setSelectedShipmentTerms([]);
    setEditableItem({});
    clearErrors();
    reset();
  };

  useEffect(() => {
    console.log("errors", errors);
  }, [errors]);

  const [selectedMarket, setSelectedMarket] = useState(0);
  // const [servicesError, setServicesError] = useState<string>("");
  const [services, setServices] = useState<
    {
      region: number;
      regulatory_compliance: boolean;
      importation_clearance: boolean;
      warehousing_storage: boolean;
      ecom_setup_mgmt: boolean;
      retail_distribution: boolean;
      order_fulfilment: boolean;
      marketing: boolean;
    }[]
  >([]);

  const [selectedServices, setSelectedServices] = useState<any[]>([]);
  const [selectedEngagementModels, setSelectedEngagementModels] = useState<
    any[]
  >([]);
  const [selectedCategories, setSelectedCategories] = useState<any[]>([]);
  const [selectedShipmentTerms, setSelectedShipmentTerms] = useState<any[]>([]);
  const [selectedPaymentTerms, setSelectedPaymentTerms] = useState<any[]>([]);

  const [marketsList, setMarketsList] = useState<any>([]);
  const [usedMarketIds, setUsedMarketIds] = useState<number[]>([]);
  const [deletableItem, setDeletableItem] = useState("");
  const [editableItem, setEditableItem] = useState<any>({});

  const [isDisabled, setIsDisabled] = useState(true);
  const [notification, setNotification] = useState({ type: "", msg: "" });

  const navigate = useNavigate();

  const termsList: any[] = [
    {
      id: "CIF",
      name: "CIF",
    },
    {
      id: "FOB",
      name: "FOB",
    },
  ];

  const paymentTermsList: any[] = [
    {
      id: "COD",
      name: "COD",
    },
    {
      id: "Bank LC",
      name: "Bank LC",
    },
    {
      id: "30-60 Days Credit",
      name: "30-60 Days Credit",
    },
    {
      id: "Escrow",
      name: "Escrow",
    },
  ];

  const exclusivityList: any[] = [
    {
      id: 1,
      name: "Yes",
    },
    {
      id: 0,
      name: "No",
    },
  ];

  const investmentsList: any[] = [
    {
      id: "YES",
      name: "Yes",
    },
    {
      id: "NO",
      name: "No",
    },
    {
      id: "MAYBE",
      name: "Maybe",
    },
  ];

  useEffect(() => {
    if (params?.partnerid && props.data) {
      console.log("marksets", props.data);

      setMarketsList(
        props.data?.map((item: any) => {
          const selectedMarket = item?.country;
          const selectedExclusivity = exclusivityList.find(
            (e) => Boolean(e.id) === item?.exclusivity
          );

          const selectedTenure = props?.tenureList.find(
            (t) => t.name === item?.minimum_tenure
          );

          const selectedInvestment = investmentsList.find(
            (i) => i.id === item?.trade_marketing_investments
          );

          const services = props.servicesList.filter((s: any) =>
            item?.service_capabilities?.includes(s.name)
          );
          const engagementModels = props.engagementModelList.filter((s: any) =>
            item?.engagement_model?.includes(s.name)
          );
          const catFocus = props.categories.filter((s: any) =>
            item?.category_focus?.includes(s.display_name)
          );

          const shipmentsTerms = termsList.filter((s: any) =>
            item?.shipment_terms?.includes(s.id)
          );
          const paymentTerms = paymentTermsList.filter((s: any) =>
            item?.payment_terms?.includes(s.id)
          );

          return {
            id: item?.id,
            market: selectedMarket,
            exclusivity: selectedExclusivity,
            minimum_tenure: selectedTenure,
            shipment_terms: shipmentsTerms,
            payment_terms: paymentTerms,
            investments: selectedInvestment,
            services: services,
            engagement_model: engagementModels,
            category_focus: catFocus,
            remarks: item?.remarks,
          };
        })
      );
    }
  }, [params?.partnerid, props.data]);

  const onSubmit = (event: { preventDefault: () => void }) => {
    event.preventDefault();
    console.log("marketsList", marketsList);

    if (marketsList.length > 0) {
      if (params.partnerid) {
        marketsList.forEach(async (item: any) => {
          const marketReq = {
            partner_id: params.partnerid,
            region: item?.market?.id,
            service_capabilities: item?.services?.map(
              (service: any) => service?.name
            ),
            engagement_model: item?.engagement_model?.map(
              (model: any) => model?.name
            ),
            shipment_terms: item?.shipment_terms?.map(
              (terms: any) => terms?.id
            ),
            payment_terms: item?.payment_terms?.map((terms: any) => terms?.id),
            category_focus: item?.category_focus?.map((cat: any) => cat?.id),
            exclusivity: item?.exclusivity?.id ? true : false,
            minimum_tenure: item?.minimum_tenure?.name,
            trade_marketing_investments: item?.investments?.id,
            remarks: item.remarks ? item.remarks : item.exist ? "" : undefined,
          };

          if (!Boolean(item?.id)) {
            const createdRes = await createMarket(marketReq);
          } else {
            if (item.exist) {
              const updateRes = await updateMarket(item?.id, marketReq);
            }
          }
        });

        navigate(-1);
        // (async () => {
        //   await UpdatePartnerServices(params.partnerid, services);
        //   // console.log(props.isActivePartner);
        //   // await CreatePartnerServices(props.partnerID, services);
        //   props.isActivePartner &&
        //     !props.isSuperAdmin &&
        //     // props.setDefaultTab("agreement");
        //     navigate("/PartnerManagement");
        //   setNotification({
        //     type: "success",
        //     msg: "Updated successfully",
        //   });
        // })();
      } else {
        props.onContinue("partner-service-capabilities", true, marketsList);
        // (async () => {
        //   await CreatePartnerServices(props.partnerID, services);
        //   // !props.isSuperAdmin && props.setDefaultTab("agreement");
        //   !props.isSuperAdmin && navigate("/PartnerManagement");
        //   props.isSuperAdmin && navigate("/PartnerManagement");
        // })();
      }
    } else {
      // setServicesError("Services list cannot be empty");
    }
  };

  const deleteFromList = (del: any) => {
    let newServicesList = services.filter((service) => service.region !== del);
    setServices(newServicesList);
  };

  // const addToList = () => {
  //   let list = {
  //     region: selectedMarket,
  //     regulatory_compliance: regulatoryCompliance,
  //     importation_clearance: importClearance,
  //     warehousing_storage: warehousingAndStorage,
  //     ecom_setup_mgmt: ecomSetupMgmt,
  //     retail_distribution: retailDistribution,
  //     order_fulfilment: orderFullfilment,
  //     marketing: marketing,
  //   };
  //   let flag = false;
  //   setServicesError("");
  //   services.map((service) => {
  //     console.log(service.region, selectedMarket);
  //     if (service.region.toString() === selectedMarket.toString()) {
  //       flag = true;
  //       setServicesError("Service Capabilities in the region already exists.");
  //       return true;
  //     }
  //     return true;
  //   });

  //   if (!flag) {
  //     setServices([...services, list]);
  //     setServicesError("");
  //   }
  // };

  useEffect(() => {
    setSelectedMarket(props?.countries[0]?.id);
    (async () => {
      const countries = await GetCountries();
    })();
  }, [props]);

  useEffect(() => {
    params.partnerid &&
      (async () => {
        const res = await GetPartnerServicesList(params.partnerid);
        const servicesAdded = res.data.services;
        setServices([]);
        servicesAdded.map((service: partnerServiceCapabilities) => {
          let servicesList = {
            region: service.regions.id,
            regulatory_compliance:
              service.pre_launch_services.regulatory_compliance,
            importation_clearance:
              service.pre_launch_services.importation_clearance,
            warehousing_storage:
              service.pre_launch_services.warehousing_storage,
            ecom_setup_mgmt: service.post_launch_services.ecom_setup_mgmt,
            retail_distribution:
              service.post_launch_services.retail_distribution,
            order_fulfilment: service.post_launch_services.order_fulfilment,
            marketing: service.post_launch_services.marketing,
          };
          setServices((prevState) => [...prevState, servicesList]);
          return true;
        });
      })();
  }, [params.partnerid]);

  useEffect(() => {
    setUsedMarketIds(marketsList.map((item: any) => item?.market?.id));
  }, [marketsList]);

  useEffect(() => {
    if (editableItem && Object.keys(editableItem).length > 0 && Boolean(open)) {
      console.log("editableItem", editableItem);

      setSelectedCategories(editableItem?.category_focus);
      setSelectedServices(editableItem?.services);
      setSelectedEngagementModels(editableItem?.engagement_model);
      setSelectedShipmentTerms(editableItem?.shipment_terms);
      setSelectedPaymentTerms(editableItem?.payment_terms);

      let defaults = {
        market: editableItem?.market?.id,
        exclusivity: editableItem?.exclusivity?.id,
        minimum_tenure: editableItem?.minimum_tenure,
        investments: editableItem?.investments?.id,
        remarks: editableItem?.remarks,
      };
      reset(defaults);
    }
  }, [editableItem, reset, open, setValue]);

  const handleCloseNotification = () =>
    setNotification({
      type: "",
      msg: "",
    });

  const onSubmitNewMarket = (data: any) => {
    if (!validateForm()) {
      return;
    }

    if (data) {
      const selectedMarket = props.countries.find(
        (item) => item.id === data?.market
      );
      const selectedExclusivity = exclusivityList.find(
        (item) => item.id === data?.exclusivity
      );
      const selectedTenure = props?.tenureList.find(
        (item) => item.id === data?.minimum_tenure
      );
      const selectedInvestment = investmentsList.find(
        (item) => item.id === data?.investments
      );

      if (editableItem && Object.keys(editableItem).length > 0) {
        let index = marketsList.findIndex(
          (item: any) => item?.market?.id === editableItem?.market?.id
        );
        if (index > -1) {
          let items = [...marketsList];
          items[index] = {
            ...data,
            market: selectedMarket,
            exclusivity: selectedExclusivity,
            minimum_tenure: selectedTenure,
            shipment_terms: selectedShipmentTerms,
            payment_terms: selectedPaymentTerms,
            investments: selectedInvestment,
            services: selectedServices.sort((a, b) => a.id - b.id),
            engagement_model: selectedEngagementModels,
            category_focus: selectedCategories,
            exist: editableItem?.exist,
            id: editableItem?.id,
          };
          setMarketsList([...items]);
        }
      } else {
        setMarketsList([
          ...marketsList,
          {
            ...data,
            market: selectedMarket,
            exclusivity: selectedExclusivity,
            minimum_tenure: selectedTenure,
            shipment_terms: selectedShipmentTerms,
            payment_terms: selectedPaymentTerms,
            investments: selectedInvestment,
            services: selectedServices.sort((a, b) => a.id - b.id),
            engagement_model: selectedEngagementModels,
            category_focus: selectedCategories,
          },
        ]);
      }
    }
    setOpen("");
    setSelectedServices([]);
    setSelectedEngagementModels([]);
    setSelectedCategories([]);
    setSelectedPaymentTerms([]);
    setSelectedShipmentTerms([]);
    setEditableItem({});
    clearErrors();
    reset();
  };

  const validateForm = () => {
    selectedServices.length == 0
      ? setError("services", {
          type: "manual",
          message: "* This field is required",
        })
      : clearErrors("services");

    selectedPaymentTerms.length == 0
      ? setError("payment_terms", {
          type: "manual",
          message: "* This field is required",
        })
      : clearErrors("payment_terms");

    selectedShipmentTerms.length == 0
      ? setError("shipment_terms", {
          type: "manual",
          message: "* This field is required",
        })
      : clearErrors("shipment_terms");

    selectedEngagementModels.length == 0
      ? setError("engagement_model", {
          type: "manual",
          message: "* This field is required",
        })
      : clearErrors("engagement_model");

    selectedCategories.length == 0
      ? setError("category_focus", {
          type: "manual",
          message: "* This field is required",
        })
      : clearErrors("category_focus");

    if (
      selectedServices.length == 0 ||
      selectedPaymentTerms.length == 0 ||
      selectedShipmentTerms.length == 0 ||
      selectedEngagementModels.length == 0 ||
      selectedCategories.length == 0
    ) {
      return false;
    }

    return true;
  };

  const onDeleteMarketItem = (marketID: number) => {
    setDeletableItem(String(marketID));
  };

  const deleteItem = (id: any) => {
    let allItems = [...marketsList];
    let newItemsList = allItems.filter(
      (item) => item?.market?.id !== parseInt(id)
    );
    setMarketsList([...newItemsList]);
  };
  const handleCloseDeleteModal = () => {
    setDeletableItem("");
  };

  const onEditMarketItem = (marketID: number, exist: boolean) => {
    let selectedItem = marketsList.find(
      (item: any) => item?.market?.id === marketID
    );

    console.log("selectedItem", selectedItem, marketID);

    setEditableItem({ ...selectedItem, exist: exist });
    setOpen("edit");
  };

  const handleServicesChange = (selectedList: any) => {
    setSelectedServices([]);
    selectedList.map(
      (item: { id: string; name: string; display_name: string }) => {
        setSelectedServices((services: any) => [
          ...services,
          {
            id: item.id,
            name: item.name,
            display_name: item.display_name,
          },
        ]);
        return true;
      }
    );
  };

  const handleRemoveService = (selectedList: any) => {
    setSelectedServices(selectedList);
  };

  const handleEngagementModelChange = (selectedList: any) => {
    setSelectedEngagementModels([]);
    selectedList.map(
      (item: { id: string; name: string; display_name: string }) => {
        setSelectedEngagementModels((models: any) => [
          ...models,
          {
            id: item.id,
            name: item.name,
            display_name: item.display_name,
          },
        ]);
        return true;
      }
    );
  };

  const handleEngagementModelRemove = (selectedList: any) => {
    setSelectedEngagementModels(selectedList);
  };

  const handleCategoryChange = (selectedList: any) => {
    setSelectedCategories([]);
    selectedList.map(
      (item: { id: string; name: string; display_name: string }) => {
        setSelectedCategories((categories: any) => [
          ...categories,
          {
            id: item.id,
            name: item.name,
            display_name: item.display_name,
          },
        ]);
        return true;
      }
    );
  };

  const handleCategoryRemove = (selectedList: any) => {
    setSelectedCategories(selectedList);
  };

  const handleShipmentChange = (selectedList: any) => {
    setSelectedShipmentTerms([]);
    selectedList.map(
      (item: { id: string; name: string; display_name: string }) => {
        setSelectedShipmentTerms((items: any) => [
          ...items,
          {
            id: item.id,
            name: item.name,
          },
        ]);
        return true;
      }
    );
  };

  const handleShipmentRemove = (selectedList: any) => {
    setSelectedShipmentTerms(selectedList);
  };

  const handlePaymentChange = (selectedList: any) => {
    setSelectedPaymentTerms([]);
    selectedList.map(
      (item: { id: string; name: string; display_name: string }) => {
        setSelectedPaymentTerms((items: any) => [
          ...items,
          {
            id: item.id,
            name: item.name,
          },
        ]);
        return true;
      }
    );
  };

  const handlePaymentRemove = (selectedList: any) => {
    setSelectedPaymentTerms(selectedList);
  };

  const servicesList = (services: any[]) => {
    return services?.map((service: any) => {
      return (
        <Col className="my-8" key={service?.id} md="auto">
          <Chip
            sx={{
              padding: "8px",
              marginRight: "8px",
              fontWeight: "400",
              width: "auto",
              background: "#F9FAFB",
              borderRadius: "2px",
              color: "#475467",
              fontSize: "12px",
            }}
            size="small"
            label={service?.display_name}
          />
        </Col>
      );
    });
  };

  const categoriesList = (categories: any[]) => {
    return categories?.map((cat) => cat?.name).join(", ");
  };

  const engagementModelList = (models: any[]) => {
    return models?.map((model) => model?.display_name).join(", ");
  };

  const shipmentTermsList = (items: any[]) => {
    return items?.map((cat) => cat?.name).join(", ");
  };

  const paymentTermList = (items: any[]) => {
    return items?.map((cat) => cat?.name).join(", ");
  };

  const capabilitiesList = useMemo(
    () =>
      marketsList.map((market: any, index: number) => {
        return (
          <Accordion defaultExpanded={index == 0} key={index}>
            <AccordionSummary
              sx={{
                pointerEvents: "none",
              }}
              expandIcon={
                <ExpandMoreIcon
                  sx={{
                    pointerEvents: "auto",
                  }}
                />
              }
              aria-controls="panel1-content"
              id="panel1-header"
            >
              <div
                className="align-center fullwidth d-flex pl20px borderbottom"
                style={{ padding: "6px 12px" }}
              >
                {getFlagIcon(market?.market?.name)}
                <Typography className="mx-05">
                  {market?.market?.name}
                </Typography>
                <Chip
                  size="small"
                  label={`${String(market?.services?.length).padStart(
                    2,
                    "0"
                  )} ${
                    market?.services.length == 1 ? "Capability" : "Capabilities"
                  }`}
                />
                <div className="ml-auto pos">
                  <PartnerDropDown
                    onEditItem={onEditMarketItem}
                    onDeleteItem={market?.id ? null : onDeleteMarketItem}
                    countryID={market?.market?.id}
                    marketID={market?.id ? market?.id : market?.market?.id}
                    mode={params.partnerid ? "EDIT" : "ADD"}
                    reload={() => props.reload()}
                    haveDueDiligence={false}
                  />
                </div>
              </div>
            </AccordionSummary>
            <AccordionDetails>
              <Row className="row-input p-20">
                <Col sm={4} md={4} lg={4}>
                  <Row className="my-8">
                    <Typography
                      sx={{
                        fontWeight: "500",
                        borderRadius: "2px",
                        color: "#667085",
                        fontSize: "12px",
                        padding: "4px",
                      }}
                    >
                      Service Capabilities
                    </Typography>
                  </Row>
                  <Row>{servicesList(market?.services)}</Row>
                </Col>
                <Col sm={8} md={8} lg={8}>
                  <Row className="my-8">
                    <Col sm={4} md={4} lg={4}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#667085",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        Category Focus
                      </Typography>
                    </Col>
                    <Col>:</Col>
                    <Col sm={7} md={7} lg={7}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#1D2939",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        {categoriesList(market?.category_focus)}
                      </Typography>
                    </Col>
                  </Row>
                  <Row className="my-8">
                    <Col sm={4} md={4} lg={4}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#667085",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        Minimum Tenure
                      </Typography>
                    </Col>
                    <Col>:</Col>
                    <Col sm={7} md={7} lg={7}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#1D2939",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        {market?.minimum_tenure?.name}
                      </Typography>
                    </Col>
                  </Row>
                  <Row className="my-8">
                    <Col sm={4} md={4} lg={4}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#667085",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        Shipment Terms
                      </Typography>
                    </Col>
                    <Col>:</Col>
                    <Col sm={7} md={7} lg={7}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#1D2939",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        {shipmentTermsList(market?.shipment_terms)}
                      </Typography>
                    </Col>
                  </Row>
                  <Row className="my-8">
                    <Col sm={4} md={4} lg={4}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#667085",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        Engagement Model
                      </Typography>
                    </Col>
                    <Col>:</Col>
                    <Col sm={7} md={7} lg={7}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#1D2939",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        {engagementModelList(market?.engagement_model)}
                      </Typography>
                    </Col>
                  </Row>
                  <Row className="my-8">
                    <Col sm={4} md={4} lg={4}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#667085",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        Payment Terms
                      </Typography>
                    </Col>
                    <Col>:</Col>
                    <Col sm={7} md={7} lg={7}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#1D2939",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        {paymentTermList(market?.payment_terms)}
                      </Typography>
                    </Col>
                  </Row>
                  <Row className="my-8">
                    <Col sm={4} md={4} lg={4}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#667085",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        Exclusivity
                      </Typography>
                    </Col>
                    <Col>:</Col>
                    <Col sm={7} md={7} lg={7}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#1D2939",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        {market?.exclusivity?.name}
                      </Typography>
                    </Col>
                  </Row>
                  <Row className="my-8">
                    <Col sm={4} md={4} lg={4}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#667085",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        Trade and Marketing Investments
                      </Typography>
                    </Col>
                    <Col>:</Col>
                    <Col sm={7} md={7} lg={7}>
                      <Typography
                        sx={{
                          fontWeight: "500",
                          borderRadius: "2px",
                          color: "#1D2939",
                          fontSize: "12px",
                          padding: "4px",
                        }}
                      >
                        {market?.investments?.name}
                      </Typography>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </AccordionDetails>
            {market?.remarks ? (
              <Col className="bt-gray200 mx-2 py-8">
                <Typography
                  sx={{ fontSize: "12px", color: "#667085", marginTop: "10px" }}
                >
                  Remarks
                </Typography>
                <Typography sx={{ fontSize: "12px", color: "#667085" }}>
                  {market?.remarks}
                </Typography>
              </Col>
            ) : (
              <></>
            )}
          </Accordion>
        );
      }),
    [marketsList]
  );

  return (
    <div>
      <Form onSubmit={onSubmit} className="mt40px servicecpbts">
        <Container fluid className="container-1">
          <Grid
            container
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
          >
            <Button
              onClick={handleClickOpenMarket}
              className="badgepill-blue50  blue-text br-0 bold no-border d-flex h-38 align-center"
            >
              <AddIcon sx={{ fontSize: "22px", fontWeight: "500" }} />
              <Typography sx={{ fontSize: "12px", fontWeight: "500" }}>
                Add New Market
              </Typography>
            </Button>
          </Grid>

          {capabilitiesList}

          {/* <Form onSubmit={addToList} className="form">
            <Form.Text muted>
              <span>
                {servicesError && <p className="error-form">{servicesError}</p>}
              </span>
            </Form.Text>

            {services[0] &&
              services.map((service) => {
                return (
                  <>
                    <Row
                      className="b-gray200 mt24px row-output"
                      key={service.region}
                    >
                      <Col
                        sm={3}
                        md={3}
                        lg={3}
                        className="br-gray200 col-market"
                      >
                        <Form.Group
                          className="formgroup"
                          controlId="formSocialMediaName"
                        >
                          <Form.Control
                            type="text"
                            disabled
                            placeholder={
                              allCountries?.filter((country: any) => {
                                return (
                                  country.id?.toString() ===
                                  service.region?.toString()
                                );
                              })[0]?.name || "Singapore"
                            }
                          />
                        </Form.Group>
                      </Col>
                      <Col
                        sm={8}
                        md={8}
                        lg={8}
                        className="br-gray200 col-services"
                      >
                        <Row>
                          <Col sm={6} lg={4} xl={3}>
                            <Form.Check
                              type="checkbox"
                              id="regulatorycompliance"
                              className="font14-regular gray-700"
                              label="Regulatory Compliance"
                              disabled={isDisabled}
                              defaultChecked={service.regulatory_compliance}
                              onChange={(e) => {
                                service.regulatory_compliance =
                                  !service.regulatory_compliance;
                              }}
                            />
                          </Col>
                          <Col sm={6} lg={4} xl={3}>
                            <Form.Check
                              type="checkbox"
                              id="importClearance"
                              className="font14-regular gray-700"
                              label="Importation And Clearance"
                              disabled={isDisabled}
                              defaultChecked={service.importation_clearance}
                              onChange={(e) => {
                                service.importation_clearance =
                                  !service.importation_clearance;
                              }}
                            />
                          </Col>
                          <Col sm={6} lg={4} xl={3}>
                            <Form.Check
                              type="checkbox"
                              id="warehousingandstorage"
                              className="font14-regular gray-700"
                              label="Warehousing And Storage"
                              disabled={isDisabled}
                              defaultChecked={service.warehousing_storage}
                              onChange={(e) => {
                                service.warehousing_storage =
                                  !service.warehousing_storage;
                              }}
                            />
                          </Col>
                          <Col sm={6} lg={4} xl={3}>
                            <Form.Check
                              type="checkbox"
                              id="ecommerceSetup"
                              className="font14-regular gray-700"
                              label="Ecommerce Setup And Management"
                              disabled={isDisabled}
                              defaultChecked={service.ecom_setup_mgmt}
                              onChange={(e) => {
                                service.ecom_setup_mgmt =
                                  !service.ecom_setup_mgmt;
                              }}
                            />
                          </Col>
                          <Col sm={6} lg={4} xl={3}>
                            <Form.Check
                              type="checkbox"
                              id="retaildistribution"
                              className="font14-regular gray-700"
                              label="Retail Distribution"
                              disabled={isDisabled}
                              defaultChecked={service.retail_distribution}
                              onChange={(e) => {
                                service.retail_distribution =
                                  !service.retail_distribution;
                              }}
                            />
                          </Col>
                          <Col sm={6} lg={4} xl={3}>
                            <Form.Check
                              type="checkbox"
                              id="orderFullfilment"
                              className="font14-regular gray-700"
                              label="Order Fulfilment"
                              disabled={isDisabled}
                              defaultChecked={service.order_fulfilment}
                              onChange={(e) => {
                                service.order_fulfilment =
                                  !service.order_fulfilment;
                              }}
                            />
                          </Col>
                          <Col sm={6} lg={4} xl={3}>
                            <Form.Check
                              type="checkbox"
                              id="marketing"
                              className="font14-regular gray-700"
                              label="Marketing"
                              disabled={isDisabled}
                              defaultChecked={service.marketing}
                              onChange={(e) => {
                                service.marketing = !service.marketing;
                              }}
                            />
                          </Col>
                        </Row>
                      </Col>
                      <Col sm={1} md={1} lg={1} className="col-action">
                        {isDisabled &&
                          props?.permissions[0]?.sub_modules[2]
                            ?.permissions_actions[2]?.permission[0]
                            ?.permission && (
                            <OverlayTrigger
                              key="editbutton"
                              placement="left"
                              overlay={
                                <Tooltip id="tooltip-top" className="tooltip">
                                  Edit Selection
                                </Tooltip>
                              }
                            >
                              <img
                                className="listicon"
                                src="../svgs/pencil.svg"
                                alt="editbutton"
                                onClick={() => {
                                  setIsDisabled(false);
                                }}
                              />
                            </OverlayTrigger>
                          )}
                        {!isDisabled && (
                          <OverlayTrigger
                            key="confirmbutton"
                            placement="left"
                            overlay={
                              <Tooltip id="tooltip-top" className="tooltip">
                                Confirm Edit
                              </Tooltip>
                            }
                          >
                            <img
                              className="listicon"
                              src="../svgs/check.svg"
                              alt="confirmbutton"
                              onClick={() => {
                                const editedService = {
                                  region: service.region,
                                  regulatory_compliance:
                                    service.regulatory_compliance,
                                  importation_clearance:
                                    service.importation_clearance,
                                  warehousing_storage:
                                    service.warehousing_storage,
                                  ecom_setup_mgmt: service.ecom_setup_mgmt,
                                  retail_distribution:
                                    service.retail_distribution,
                                  order_fulfilment: service.order_fulfilment,
                                  marketing: service.marketing,
                                };
                                let newServicesList = services.filter(
                                  (selection) =>
                                    selection.region !== service.region
                                );
                                setServices([
                                  ...newServicesList,
                                  editedService,
                                ]);
                                setIsDisabled(true);
                              }}
                            />
                          </OverlayTrigger>
                        )}
                        {props?.permissions[0]?.sub_modules[2]
                          ?.permissions_actions[3]?.permission[0]
                          ?.permission && (
                          <img
                            src="../svgs/trash.svg"
                            alt="trashbutton"
                            className="listicon"
                            onClick={() => {
                              deleteFromList(service.region);
                            }}
                          />
                        )}
                      </Col>
                    </Row>
                  </>
                );
              })}
          </Form> */}
        </Container>
        <Container fluid className="bt-gray200 mt40px">
          <Row className="justify-content-end mb-3 mt-4">
            <Col className="d-flex justify-content-end">
              <Link to="/PartnerManagement" className="m-1">
                <Button variant="secondary" className="btn-secondary12">
                  Cancel
                </Button>
              </Link>
              {props?.permissions[0]?.sub_modules[2]?.permissions_actions[2]
                ?.permission[0]?.permission &&
                params.partnerid && (
                  <Button
                    variant="primary"
                    className="btn-primary12 m-1"
                    type="submit"
                  >
                    Update
                  </Button>
                )}
              {props?.permissions[0]?.sub_modules[2]?.permissions_actions[0]
                ?.permission[0]?.permission &&
                !params.partnerid && (
                  <Button
                    variant="primary"
                    className="btn-primary12 m-1"
                    type="submit"
                  >
                    Save and continue
                  </Button>
                )}
            </Col>
          </Row>
        </Container>
        <ToastMessage
          notification={notification}
          onCancel={handleCloseNotification}
        />
      </Form>

      <Dialog
        className="modal_700 add-new-market-modal"
        open={Boolean(open)}
        onClose={handleCloseMarket}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        
      >
        <DialogTitle id="alert-dialog-title">
          {Object.keys(editableItem).length > 0
            ? "Edit Market"
            : "Add New Market"}
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleCloseMarket}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
        <Form onSubmit={handleSubmit(onSubmitNewMarket)} className="add-market-form">
          <DialogContent>
            <Row className="mb16px">
              <Col sm={6} lg={6} xl={6}>
                <FormControl sx={{ minWidth: "100%" }} size="small">
                  <label>Market</label>
                  <Select
                    placeholder="Select Market"
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    label="market"
                    {...register("market", {
                      required: "* This field is required",
                    })}
                  >
                    {props.countries &&
                      props.countries.map((country) => {
                        return (
                          <MenuItem
                            value={country.id}
                            key={country.id}
                            disabled={
                              usedMarketIds.includes(country.id)
                                ? Object.keys(editableItem).length > 0
                                  ? editableItem?.market?.id === country.id
                                    ? false
                                    : true
                                  : true
                                : false
                            }
                          >
                            {country.name}
                          </MenuItem>
                        );
                      })}
                  </Select>
                  <Form.Text muted>
                    <span>
                      <p className="error-form">{errors.market?.message}</p>
                    </span>
                  </Form.Text>
                </FormControl>
              </Col>
              <Col sm={6} lg={6} xl={6}>
                <FormControl sx={{ width: "100%" }} size="small">
                  <label>Services Capability</label>
                  <Multiselect
                    key="services"
                    showArrow
                    options={props?.servicesList}
                    displayValue="display_name"
                    showCheckbox={true}
                    customCloseIcon={<></>}
                    placeholder="Select Services"
                    closeIcon="cancel"
                    {...register("services")}
                    selectedValues={selectedServices}
                    onSelect={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleServicesChange(e);
                    }}
                    onRemove={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleRemoveService(e);
                    }}
                  />
                  <Form.Text muted>
                    <span>
                      <p className="error-form">{errors.services?.message}</p>
                    </span>
                  </Form.Text>
                </FormControl>
              </Col>
            </Row>
            <Row className="mb16px">
              <Col sm={6} lg={6} xl={6}>
                <FormControl sx={{ width: "100%" }} size="small">
                  <label>Engagement Model</label>
                  <Multiselect
                    {...register("engagement_model")}
                    showArrow
                    options={props.engagementModelList}
                    displayValue="display_name"
                    showCheckbox={true}
                    placeholder="Select Engagement Models"
                    closeIcon="cancel"
                    customCloseIcon={<></>}
                    selectedValues={selectedEngagementModels}
                    onSelect={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleEngagementModelChange(e);
                    }}
                    onRemove={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleEngagementModelRemove(e);
                    }}
                  />
                  <Form.Text muted>
                    <span>
                      <p className="error-form">
                        {errors.engagement_model?.message}
                      </p>
                    </span>
                  </Form.Text>
                </FormControl>
              </Col>
              <Col sm={6} lg={6} xl={6}>
                <FormControl sx={{ minWidth: "100%" }} size="small">
                  <label>Exclusivity</label>
                  <Select
                    placeholder="Select Exclusivity"
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    label="exclusivity"
                    {...register("exclusivity", {
                      required: "* This field is required",
                    })}
                  >
                    {exclusivityList.map((term) => {
                      return (
                        <MenuItem value={term.id} key={term.id}>
                          {term.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <Form.Text muted>
                    <span>
                      <p className="error-form">
                        {errors.exclusivity?.message}
                      </p>
                    </span>
                  </Form.Text>
                </FormControl>
              </Col>
            </Row>
            <Row className="mb16px">
              <Col sm={6} lg={6} xl={6}>
                <FormControl sx={{ minWidth: "100%" }} size="small">
                  <label>Minimum Tenure</label>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    label="tenure"
                    placeholder="Select Minimum Tenure"
                    {...register("minimum_tenure", {
                      required: "* This field is required",
                    })}
                  >
                    {props?.tenureList.map((tenure) => {
                      return (
                        <MenuItem value={tenure.id} key={tenure.id}>
                          {tenure.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <Form.Text muted>
                    <span>
                      <p className="error-form">
                        {errors.minimum_tenure?.message}
                      </p>
                    </span>
                  </Form.Text>
                </FormControl>
              </Col>
              <Col sm={6} lg={6} xl={6}>
                <FormControl sx={{ width: "100%" }} size="small">
                  <label>Shipment terms</label>
                  <Multiselect
                    showArrow
                    options={termsList}
                    displayValue="name"
                    showCheckbox={true}
                    placeholder="Select Shipment Terms"
                    closeIcon="cancel"
                    customCloseIcon={<></>}
                    {...register("shipment_terms")}
                    selectedValues={selectedShipmentTerms}
                    onSelect={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleShipmentChange(e);
                    }}
                    onRemove={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleShipmentRemove(e);
                    }}
                  />
                  <Form.Text muted>
                    <span>
                      <p className="error-form">
                        {errors.shipment_terms?.message}
                      </p>
                    </span>
                  </Form.Text>
                </FormControl>
              </Col>
            </Row>
            <Row className="mb16px">
              <Col sm={6} lg={6} xl={6}>
                <FormControl sx={{ width: "100%" }} size="small">
                  <label>Payment terms</label>
                  <Multiselect
                    showArrow
                    options={paymentTermsList}
                    displayValue="name"
                    showCheckbox={true}
                    customCloseIcon={<></>}
                    placeholder="Select Payment Terms"
                    closeIcon="cancel"
                    {...register("payment_terms")}
                    selectedValues={selectedPaymentTerms}
                    onSelect={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handlePaymentChange(e);
                    }}
                    onRemove={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handlePaymentRemove(e);
                    }}
                  />
                  <Form.Text muted>
                    <span>
                      <p className="error-form">
                        {errors.payment_terms?.message}
                      </p>
                    </span>
                  </Form.Text>
                </FormControl>
              </Col>
              <Col sm={6} lg={6} xl={6}>
                <FormControl sx={{ minWidth: "100%" }} size="small">
                  <label>Trade and Marketing Investements</label>
                  <Select
                    labelId="demo-select-small-label"
                    id="demo-select-small"
                    label="investments"
                    placeholder="Select"
                    {...register("investments", {
                      required: "* This field is required",
                    })}
                  >
                    {investmentsList.map((term) => {
                      return (
                        <MenuItem value={term.id} key={term.id}>
                          {term.name}
                        </MenuItem>
                      );
                    })}
                  </Select>
                  <Form.Text muted>
                    <span>
                      <p className="error-form">
                        {errors.investments?.message}
                      </p>
                    </span>
                  </Form.Text>
                </FormControl>
              </Col>
            </Row>
            <Row className="mb16px">
              <Col>
                <FormControl sx={{ width: "100%" }} size="small">
                  <label>Category Focus</label>
                  <Multiselect
                    showArrow
                    options={props.categories}
                    displayValue="name"
                    showCheckbox={true}
                    customCloseIcon={<></>}
                    placeholder="Select"
                    closeIcon="cancel"
                    {...register("category_focus")}
                    selectedValues={selectedCategories}
                    onSelect={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleCategoryChange(e);
                    }}
                    onRemove={(e: React.ChangeEvent<HTMLSelectElement>) => {
                      handleCategoryRemove(e);
                    }}
                  />
                  <Form.Text muted>
                    <span>
                      <p className="error-form">
                        {errors.category_focus?.message}
                      </p>
                    </span>
                  </Form.Text>
                </FormControl>
              </Col>
            </Row>
            <Row className="mb16px">
              <Col sm={12} lg={12} xl={12}>
                <Form.Group controlId="">
                  <label>Remarks</label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    placeholder="sample text"
                    {...register("remarks")}
                  />
                  <Form.Text muted>
                    <span>
                      <p className="error-form">{errors.remarks?.message}</p>
                    </span>
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" onClick={handleCloseMarket}>
              Cancel
            </Button>
            <Button type="submit">
              Save
            </Button>
          </DialogActions>
        </Form>
      </Dialog>

      <PopupTemplate
        popupHeader="Confirm Market Deletion"
        popupBody="Are you sure you want to delete market ?"
        handleFunction={deleteItem}
        isModalOpen={Boolean(deletableItem)}
        onCancel={handleCloseDeleteModal}
        id={deletableItem}
      />
    </div>
  );
}

export default PartnerServiceCapabilitiesNew;
